import { render, staticRenderFns } from "./ParticipantCreate.vue?vue&type=template&id=67f64d96&scoped=true&"
import script from "./ParticipantCreate.vue?vue&type=script&lang=js&"
export * from "./ParticipantCreate.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantCreate.vue?vue&type=style&index=0&id=67f64d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f64d96",
  null
  
)

export default component.exports